import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

export const PiplResultRecord = ({
  node,
  emailCount,
  socialProfileCount,
}) => {

  const addresses = _.get(
    node,
    "addresses[0].address",
    ""
  );

  let countContent;

  if (!emailCount) {
      countContent = `Social Profile(s) Found: ${socialProfileCount}`;
  } else {
    countContent = `Email(s) Found: ${emailCount}`;
  }

  return (
    <Table className="sub-table">
      <Table.Body>
        <Table.Row>
          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            DOB/Age:
            {_.get(
              node,
              "dob[0].display[0]._",
              "NA"
            )}
          </Table.Cell>

          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            Gender:
            {_.get(
              node,
              "gender[0].content[0]._",
              "NA"
            )}
          </Table.Cell>
          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            City/State:
            {addresses &&
                _.map(
                  _.uniq(
                    _.map(addresses, address => {
                      const city = _.get(address, "city[0]._");
                      const state = _.get(address, "state[0]._");

                      return city && state
                        ? `${city}, ${state}`
                        : city || state;
                    })
                  ),
                  (location, index) => (
                    <div key={`address_${index}`}>
                      {location}
                    </div>
                  )
                )
              }
          </Table.Cell>
          <Table.Cell
            className="sub-table-cell text-bold"
            width={3}
          >
            {countContent}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default PiplResultRecord;


// WEBPACK FOOTER //
// ./src/components/searchresults/PiplResultRecord.js